var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.catalog.name)?_c('div',[_vm._v(" "+_vm._s(_vm.catalog.alias ? ((_vm.catalog.alias) + " - " + (_vm.catalog.name)): _vm.catalog.name)+" ")]):_c('div',{staticClass:"loading-pill ui-mb-2"})])}
var staticRenderFns = []

export { render, staticRenderFns }